import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 1,
  class: "container"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-10 col-md-12 offset-lg-1" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeEditor = _resolveComponent("AlternativeEditor")!

  return (_ctx.rm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isConfirmationVisible === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-title" }, "Thank you!", -1 /* CACHED */)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "card-text lead" }, "We've got your request. Do you want to add another?", -1 /* CACHED */)),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args))),
                    type: "button",
                    class: "btn btn-primary"
                  }, "Add another")
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isConfirmationVisible === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.rm.LogoUrl,
                    style: {"margin-top":"15px"}
                  }, null, 8 /* PROPS */, _hoisted_8),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", {
                    innerHTML: _ctx.rm.ContentHtml
                  }, null, 8 /* PROPS */, _hoisted_9),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  (_ctx.rm)
                    ? (_openBlock(), _createBlock(_component_AlternativeEditor, {
                        key: 0,
                        propRm: _ctx.rm.AlternativeEditor,
                        propErrors: _ctx.errors,
                        propFormId: "requestPageAlternativeForm",
                        onFormSubmit: _ctx.save
                      }, null, 8 /* PROPS */, ["propRm", "propErrors", "onFormSubmit"]))
                    : _createCommentVNode("v-if", true),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[9] || (_cache[9] = _createElementVNode("button", {
                    type: "submit",
                    form: "requestPageAlternativeForm",
                    class: "btn btn-primary"
                  }, "Confirm", -1 /* CACHED */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}